import { render, staticRenderFns } from "./TermsConvocatory.vue?vue&type=template&id=28bd4f02&scoped=true"
import script from "./TermsConvocatory.vue?vue&type=script&lang=js"
export * from "./TermsConvocatory.vue?vue&type=script&lang=js"
import style0 from "./TermsConvocatory.vue?vue&type=style&index=0&id=28bd4f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd4f02",
  null
  
)

export default component.exports